import axios from 'axios';
import { URL_GET_USER_INFO } from '../../constants/urls.js';

const getUserInfo = async () => {
	const data = await axios({
		method: 'GET',
		url: URL_GET_USER_INFO,
	});
	return data;
};

export default getUserInfo;
